module.exports = __webpack_public_path__ + "assets/cf5bd3b5b39b41c3fedbbaaabf123341.png";